import { GrapeVarieties } from '../utils/constants';

export function getGrapeVarietiesFilterOptions(currentFilters, filteredWines) {
    const grapeVarietiesArray = Object.values(GrapeVarieties).sort(); // Sort alphabetically

    var filters;
    if (currentFilters.grapes?.includes('mono')) {
        const availableMonocastVarieties = filteredWines.filter(wine => wine.grapeVarieties.length === 1).map(wine => wine.grapeVarieties[0]);
        filters = grapeVarietiesArray
                        .filter(grapeVariety => availableMonocastVarieties.includes(grapeVariety))
                        .map(grapeVariety => ({ value: grapeVariety, label: grapeVariety }));
    }
    else {
        const selectedGrapes = new Set(currentFilters.grapes);

        const newFilteredWines = filteredWines?.filter(wine =>
            selectedGrapes.size === 0 || [...selectedGrapes].every(grape => wine.grapeVarieties.includes(grape))
        ) || [];

        const uniqueGrapes = new Set();

        newFilteredWines.forEach(wine => {
          wine.grapeVarieties?.forEach(grape => {
              uniqueGrapes.add(grape);
          });
        });

        if (!currentFilters.grapes?.includes('all')) {
        filters = grapeVarietiesArray
                .filter(grapeVariety => uniqueGrapes?.has(grapeVariety))
                .map(grapeVariety => ({ value: grapeVariety, label: grapeVariety }));
        }
        else {
            filters = uniqueGrapes?.map(grapeVariety => ({ value: grapeVariety, label: grapeVariety }));
        }
    }
    
    if (currentFilters.grapes?.includes('mono') || filteredWines?.some(wine => wine.grapeVarieties?.length === 1)) {
        filters.unshift({value: 'mono', label: { en: "Single Varietal", pt: "Monocasta" }});
    }

    filters.unshift({value: 'all', label: { en: "All", pt: "Todos" }});
    return filters;
}

export function grapeVarietyFilterApplier(filters, wine) {
    if (filters.grapes?.length === 0 || filters.grapes[0] === 'all')
        return true;
    
    if (filters.grapes?.some(val => val === 'mono')) {
        if (filters.grapes.length === 1) {
            return wine.grapeVarieties?.length === 1;
        }
        else {
            const otherVarieties = filters.grapes.filter(grape => grape !== 'mono');
            return wine.grapeVarieties?.length === 1 && otherVarieties.includes(wine.grapeVarieties[0]);
        }
    }
    // return wine.grapeVarieties?.some(grapeVariety => filters.grapes?.includes(grapeVariety));
    return filters.grapes?.every(grapeVariety => wine.grapeVarieties?.includes(grapeVariety));
}